import { render, staticRenderFns } from "./SavingsChart.vue?vue&type=template&id=3b5654d8&"
import script from "./SavingsChart.vue?vue&type=script&lang=js&"
export * from "./SavingsChart.vue?vue&type=script&lang=js&"
import style0 from "./SavingsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports